module.exports = __webpack_public_path__ + "static/media/newcastle.902275d1.png";